export default __webpack_public_path__ + "static/media/image1.67fc0a28.jpg";